import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Home from "../components/Home/Home";
import Home1 from "../components/Home/Home1";
import Home2 from "../components/Home/Home2";
import Home4 from "../components/Home/Home4";
import { Helmet } from "react-helmet";

const Homes = () => {
  return (
    <div>
      <Helmet>
        <title>
          Due date calculator|Pregnancy essentials at one place!- PreggyZone
        </title>
        <meta
          name="description"
          content="Get essential mother & baby info for all 40 weeks, food Suggestions, Trying to Conceive Tips, workouts during pregnancy, and Postpartum Recovery Tips."
        />
        <meta
          name="keywords"
          content="Pregnancy, pregnancy symptoms, pregnancy stages, Due date calculator"
        />
      </Helmet>
      <Home />
      <Home1 />
      <Home2 />
      {/* <Home3 /> */}
      <Home4 />
    </div>
  );
};

export default Homes;
